module.exports = __webpack_public_path__ + "static/media/iposture.a6db4cfd.svg";